// 扩展字段管理管理
import { createAPI } from '@common'

export default {
  // 新建/修改扩展字段
  postExt: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20fyu0gjfmet',
        'POST',
        { data: config.data },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20fyu0gjfmet', 'POST', { data: config.data }, null)
    }
  },
  // 扩展字段详情
  getExt: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20fyu0gjfmet',
        'GET',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20fyu0gjfmet', 'GET', { params: config.params }, null)
    }
  },
  // 扩展字段删除
  deleteExt: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20fyu0gjfmet',
        'DELETE',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20fyu0gjfmet',
        'DELETE',
        { params: config.params },
        null
      )
    }
  },
  // 扩展字段分类
  getExtGroups: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20fyu0gjfmet0hspvqt',
        'GET',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20fyu0gjfmet0hspvqt',
        'GET',
        { params: config.params },
        null
      )
    }
  }
}
